<template>
  <div class="store">
    <div class="store-item" v-for="(item,index) in storelist" :key="index" >
      <h1>{{item.name}}</h1>
      <div>营业时间：<span>{{item.business_hours}}</span></div>
      <div>
        门店地址：<span>{{ item.address }}</span>
      </div>
      <div>联系电话：<span>{{item.phone}}</span></div>
      <!-- <div class="bus">查询班车信息</div> -->
      
    </div>
  </div>
</template>

<script>
export default {
  name: "Storeitem",
  props: {
    storelist: {
      default: []
    },
  },
  data() {
    return {
      item:[
        {id:'1',title:'上海市-中山院外店',time:'7:30-22:00',address:'上海市徐匯區平江路234-3號中山院外店 (中山醫院)',phone:'021-52270872'},
        {id:'1',title:'上海市-中山院外店',time:'7:30-22:00',address:'上海市徐匯區平江路234-3號中山院外店 (中山醫院)',phone:'021-52270872'},
        {id:'1',title:'上海市-中山院外店',time:'7:30-22:00',address:'上海市徐匯區平江路234-3號中山院外店 (中山醫院)',phone:'021-52270872'},
        {id:'1',title:'上海市-中山院外店',time:'7:30-22:00',address:'上海市徐匯區平江路234-3號中山院外店 (中山醫院)',phone:'021-52270872'},
        {id:'1',title:'上海市-中山院外店',time:'7:30-22:00',address:'上海市徐匯區平江路234-3號中山院外店 (中山醫院)',phone:'021-52270872'},
        {id:'1',title:'上海市-中山院外店',time:'7:30-22:00',address:'上海市徐匯區平江路234-3號中山院外店 (中山醫院)',phone:'021-52270872'},
        {id:'1',title:'上海市-中山院外店',time:'7:30-22:00',address:'上海市徐匯區平江路234-3號中山院外店 (中山醫院)',phone:'021-52270872'},
        
      ]

    };
  },
};
</script>

<style lang="scss" scoped>
.store {
  margin-top: 0px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .store-item {
     margin-top: 60px;
    width: 470px;
     @media (min-width: 1024px) and (max-width: 1366px) {
     height: 180px;
   }
   
    h1 {
      // margin: 30px 0 10px 0;
      margin-bottom: 20px;
      font-size: 30px;
        @media (min-width: 1024px) and (max-width: 1366px) {
    font-size: 28px;
   }
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
    }
    div {
      margin-top: 10px;
      font-size: 18px;
      line-height: 1.7;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      color: #333333;
      span {
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 0px;
        letter-spacing: 0px;
      }
    }
    .bus {
      color: white;
      text-align: center;
      width: 132px;
      margin:20px 0 50px;
      padding: 8px 16px;
      // background: #00a4a7;
      cursor: pointer;
      border-radius: 4px 4px 4px 4px;
    }
  }
}
@media (max-width:768px) {
  .store {
  margin-top: 0px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .store-item {
    margin: 0 auto;
    width: 90%;
    margin-top: 30px;
    // height: 180px;
    h1 {
      // margin: 30px 0 10px 0;
      margin-bottom: 15px;
      font-size: 26px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
    }
    div {
      margin-top: 10px;
      font-size: 18px;
      line-height: 1.7;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      color: #333333;
      span {
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 1.7;
        letter-spacing: 0px;
      }
    }
    .bus {
      color: white;
      text-align: center;
      width: 132px;
      margin:20px 0 50px;
      padding: 8px 16px;
      // background: #00a4a7;
      cursor: pointer;
      border-radius: 4px 4px 4px 4px;
    }
  }
}
}
</style>


// WEBPACK FOOTER //
// src/components/Store_item.vue